import { render, staticRenderFns } from "./ListagemProdutor.vue?vue&type=template&id=f3258d18&"
import script from "./ListagemProdutor.vue?vue&type=script&lang=js&"
export * from "./ListagemProdutor.vue?vue&type=script&lang=js&"
import style0 from "./ListagemProdutor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCard,VCardText,VCardTitle,VPagination})
